import { Grid } from '@mui/material';
import { ReactNode } from 'react';
import FormLabel from 'components/FormElements/FormLabel';
import { Box, styled, TypographyProps } from '@mui/material';
import { Row } from 'components/Layout';

const LabelTypography = styled(Box)(({ theme }) => ({
  whiteSpace: 'nowrap',
  display: 'flex',
  height: '100%',
  alignItems: 'center',
  [theme.breakpoints.down('lg')]: {
    width: theme.typography.pxToRem(110),
    minWidth: theme.typography.pxToRem(110),
    marginRight: theme.spacing(2),
  },
}));

const StyledLabelGrid = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down('lg')]: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

const StyledRow = styled(Row)(() => ({
  width: '100%',
}));

const StyledInputWrapper = styled(Box)<{ fullWidth?: boolean }>(
  ({ theme, fullWidth }) => ({
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
    flex: fullWidth ? 1 : undefined,
  }),
);

type HorizontalLabelInputGroupProps = {
  label: string;
  labelProps?: TypographyProps;
  children: ReactNode;
  informationText?: string | ReactNode;
  tooltipText?: ReactNode;
  labelColor?: string;
  size?: number;
  fullWidth?: boolean;
};

const HorizontalLabelInputGroup: React.FC<HorizontalLabelInputGroupProps> = ({
  label,
  labelProps,
  children,
  informationText,
  tooltipText,
  labelColor,
  size = 3,
  fullWidth = false,
}) => (
  <StyledLabelGrid
    container
    size={{ xs: 12, sm: 12, md: 12, lg: size }}
    spacing={3}
  >
    <StyledRow spacing="md">
      <LabelTypography>
        <FormLabel
          title={label}
          informationText={informationText}
          tooltipText={tooltipText}
          labelColor={labelColor}
          {...labelProps}
        />
      </LabelTypography>
      <StyledInputWrapper fullWidth={fullWidth}>{children}</StyledInputWrapper>
    </StyledRow>
  </StyledLabelGrid>
);

export default HorizontalLabelInputGroup;
